import {
  defFetchList,
  defFetchOne,
  defCreate,
  defUpdateOne,
  defDeleteOne,
  defUpdateStatus
} from '@/api/default'

function getTransPath (base) {
  return '/' + base + '_trans'
}

export function fetchList (base, query) {
  return defFetchList(getTransPath(base), query)
}

export function fetchOne (base, id) {
  return defFetchOne(getTransPath(base), id)
}

export function create (base, data) {
  return defCreate(getTransPath(base), data)
}

export function updateOne (base, id, data) {
  return defUpdateOne(getTransPath(base), id, data)
}

export function deleteOne (base, id) {
  return defDeleteOne(getTransPath(base), id)
}

export function updateStatus (base, id, data) {
  return defUpdateStatus(getTransPath(base), id, data)
}
